<template>
    <EmptyMessage type="bug" class="page-not-found">
        <template #title>It's not you, it's us...</template>
        <template #content>
            <p>Sorry we can't find the page you're looking for.</p>
            <p>
                <router-link :to="{ name: AppRouteNames.HOME }">Click here to go to the homepage</router-link>
            </p>
        </template>
    </EmptyMessage>
</template>

<script lang="ts" setup>
import EmptyMessage from "@/components/common/EmptyMessage.vue";
import { AppRouteNames } from "@/router/constants";
</script>

<style lang="scss">
.page-not-found {
    margin: 50px auto;
    text-align: center;

    p {
        margin: 10px 0;
    }
}
.wpp-theme--pagenotfound {
    .hoxton-footer {
        width: 100%;
    }
}
</style>
